import React, { useState, useMemo, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { useAlerta } from "utils/alertas";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";

const DocenteNotas = () => {

  const [grupos, setGrupos] = useState([]);
  const [grupoSeleccionado, setGrupoSeleccionado] = useState("");
  const [materia, setMateria] = useState("");
  const [materiasGrupo, setMateriasGrupo] = useState([]);
  const [estudiantes, setEstudiantes] = useState([]);
  const [evaluaciones, setEvaluaciones] = useState([]);
  const [evaluacionSeleccionada, setEvaluacionSeleccionada] = useState("");
  const [evaluacionAbierta, setEvaluacionAbierta] = useState(true);
  const [mensajeEvaluacion, setMensajeEvaluacion] = useState("");
  const storedUser = JSON.parse(sessionStorage.getItem("user"));
  const userId = storedUser?.id;
  const { mostrarAlerta } = useAlerta();

  const token = sessionStorage.getItem("access_token");

  const obtenerGrupos = async () => {
    try {

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/docente/grupos`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setGrupos(res.data);

    } catch (error) {
      console.error(error);
    }
  };

  const obtenerEvaluaciones = async () => {
    try {

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/evaluaciones`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setEvaluaciones(res.data);

    } catch (error) {
      console.error(error);
    }
  };

  const handleGrupoChange = async (e) => {

    const grupoId = e.target.value;
    setGrupoSeleccionado(grupoId);
    setMateria("");
    setEstudiantes([]);

    if (!grupoId) {
      setMateriasGrupo([]);
      return;
    }

    try {

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/docente/${userId}/grupos/${grupoId}/materias`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log("RESPUESTA MATERIAS:", res.data.data);

      const materias = Array.isArray(res.data?.data)
      ? res.data.data
      : Array.isArray(res.data)
      ? res.data
      : [];

    setMateriasGrupo(materias);

    } catch (error) {
      console.error(error);
    }

  };

  const handleMateriaChange = (e) => {
    console.log(materiasGrupo);
    const materiaId = e.target.value;

    setMateria(materiaId);
    setEstudiantes([]);
    setEvaluacionSeleccionada("");

  };

  const cargarEstudiantes = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/grupos/${grupoSeleccionado}/materias/${materia}/estudiantes`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { evaluacion_id: evaluacionSeleccionada }
      }
    );

    setEvaluacionAbierta(res.data.abierto);
    setMensajeEvaluacion("");

    const lista = Array.isArray(res.data)
      ? res.data
      : res.data.data || [];

    setEstudiantes(
      lista.map((est) => ({
        ...est,
        nombre: est.nombre ? est.nombre.toUpperCase() : "",
        teorico:
          est.teorico !== null && est.teorico !== undefined
            ? String(Number(est.teorico))
            : "",
        practico:
          est.practico !== null && est.practico !== undefined
            ? String(Number(est.practico))
            : ""
      }))
    );

  } catch (error) {
    console.error("Error cargando estudiantes:", error);
  }
};

  const handleNotaChange = (index, campo, valor) => {
    // Permitir vacío
    if (valor === "") {
      setEstudiantes((prev) => {
        const nuevos = [...prev];

        nuevos[index] = {
          ...nuevos[index],
          [campo]: ""
        };

        return nuevos;
      });

      return;
    }

    // Solo números
    if (!/^\d+$/.test(valor)) {
      return;
    }

    // Quitar ceros iniciales
    valor = valor.replace(/^0+(?=\d)/, "");

    setEstudiantes((prev) => {
      const nuevos = [...prev];

      nuevos[index] = {
        ...nuevos[index],
        [campo]: valor
      };

      return nuevos;
    });
  };
  const handleNotaBlur = (index, campo) => {
    setEstudiantes((prev) => {
      const nuevos = [...prev];

      const valor = nuevos[index][campo];

      if (valor === "") {
        return nuevos;
      }

      const maximo = campo === "teorico" ? 30 : 70;

      let numero = Number(valor);

      if (numero > maximo) {
        numero = maximo;
      }

      nuevos[index] = {
        ...nuevos[index],
        [campo]: String(numero)
      };

      return nuevos;
    });
  };

  useEffect(() => {

    if (grupoSeleccionado && materia && evaluacionSeleccionada) {
      cargarEstudiantes();
    }

  }, [grupoSeleccionado, materia, evaluacionSeleccionada]);

  useEffect(() => {

    obtenerGrupos();
    obtenerEvaluaciones();

  }, []);

  const columns = [
    { Header: "Nombre Completo", accessor: "nombre" },
    { Header: "Teórico (30)", accessor: "teorico" },
    { Header: "Práctico (70)", accessor: "practico" },
    { Header: "Total", accessor: "total" },
    { Header: "Estado", accessor: "estado" }
  ];

  const rows = useMemo(() => {
      return estudiantes.map((est, index) => {
        const total =
          (Number(est.teorico) || 0) +
          (Number(est.practico) || 0);
  
        const estado = total >= 61 ? "APROBADO" : "REPROBADO";
  
        return {
          nombre: est.nombre,
  
          teorico: (
            <TextField
              type="text"
              size="small"
              value={est.teorico ?? ""}
              onChange={(e) =>
                handleNotaChange(index, "teorico", e.target.value)
              }
              onBlur={() => handleNotaBlur(index, "teorico")}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*"
              }}
            />
          ),
  
          practico: (
            <TextField
              type="text"
              size="small"
              value={est.practico ?? ""}
              onChange={(e) =>
                handleNotaChange(index, "practico", e.target.value)
              }
              onBlur={() => handleNotaBlur(index, "practico")}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*"
              }}
            />
          ),
  
          total: <strong>{total}</strong>,
  
          estado: (
            <strong style={{ color: total >= 61 ? "green" : "red" }}>
              {estado}
            </strong>
          )
        };
      });
    }, [estudiantes]);

  const guardarNotas = async () => {
    const grupoEncontrado = grupos.find(g => String(g.id) === String(grupoSeleccionado));
    const esCapacitacion = grupoEncontrado && grupoEncontrado.tipo !== 'carrera';

    try {

      const data = {
      grupo_id: grupoSeleccionado,
      materia_id: materia,
      evaluacion_id: evaluacionSeleccionada,
      notas: estudiantes.map(est => ({
      estudiante_materia_id: est.estudiante_materia_id,
      teorico: Number(est.teorico) || 0,
      practico: Number(est.practico) || 0
    }))
    };
    console.log(estudiantes);
    console.log("Payload enviado desde Docente:", data);

      await axios.post(
        `${process.env.REACT_APP_API_URL}/notas`,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      mostrarAlerta("Notas guardadas correctamente","success");

    } catch (error) {
      console.error(error);
      mostrarAlerta(
        error.message || "Error al agregar grupo",
        "error"
      );
    }

  };

  return (
    <>
      {/* COMBOS */}
      <MDBox pt={3} px={3}>
        <Grid container spacing={3}>

          <Grid item xs={12} md={6}>
            <TextField
              select
              label="Grupo"
              fullWidth
              value={grupoSeleccionado}
              SelectProps={{ native: true }}
              onChange={handleGrupoChange}
            >
              <option value=""></option>
              {grupos.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.nombre}
                </option>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              select
              label="Materia"
              fullWidth
              value={materia}
              SelectProps={{ native: true }}
              onChange={handleMateriaChange}
              disabled={!grupoSeleccionado}
            >
              <option value=""></option>
              {materiasGrupo.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.asignatura}
                </option>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              select
              label="Evaluación"
              fullWidth
              value={evaluacionSeleccionada}
              SelectProps={{ native: true }}
              onChange={(e) => setEvaluacionSeleccionada(e.target.value)}
              disabled={!materia}
            >
              <option value=""></option>
              {evaluaciones.map((ev) => (
                <option key={ev.id} value={ev.id}>
                  {ev.nombre}
                </option>
              ))}
            </TextField>
          </Grid>

        </Grid>
      </MDBox>

      <MDBox pt={3}>
        {!evaluacionAbierta ? (

          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="200px"
          >
            <h2 style={{ color: "red", textAlign: "center" }}>
              {mensajeEvaluacion || "La evaluación está cerrada"}
            </h2>
          </MDBox>

        ) : (

          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={rows.length}
            pagination={false}
            showTotalEntries={false}
            noEndBorder
          />

        )}
      </MDBox>

      <MDBox p={2}>
        <MDButton
          color="success"
          onClick={guardarNotas}
          disabled={!evaluacionSeleccionada || estudiantes.length === 0}
        >
          Guardar Notas
        </MDButton>
      </MDBox>
    </>
  );

};

export default DocenteNotas;